import { FC } from 'react';
import { useHomeStore } from '@/store/home';
import {
  domainAbsolutePathReplace,
  openLink,
  replaceBybitToLocationHost,
} from '@web3/base-utils';
import { scTrack } from '@web3/base-tracking';
import { useScreenType } from '@web3/base-hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Event, Page } from '@/config/track-config';
import { Skeleton } from '@bfe/moly';

import 'swiper/css';
import 'swiper/css/pagination';

import styles from './index.module.scss';

export const Banners: FC = () => {
  const { banners, bannerIsReady } = useHomeStore();
  const { isMobile } = useScreenType();

  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return `<span class="${className}"></span>`;
    },
  };

  const displayBanners = banners.filter((banner) =>
    isMobile ? banner.appPicUrl : banner.webPicUrl
  );

  if (!bannerIsReady) {
    return (
      <>
        <div className="pc">
          <Skeleton.Bar
            style={{
              width: 600,
              height: 300,
            }}
          />
        </div>
        <div className="h5">
          <Skeleton.Bar
            style={{
              width: 343,
              height: 140,
              marginBottom: 16,
            }}
          />
        </div>
      </>
    );
  }

  return (
    <div className={styles.right}>
      <Swiper
        pagination={pagination}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop={true}
        modules={[Pagination, Autoplay]}
        className="bannerSwiper"
      >
        {displayBanners.map((banner, index) => {
          return (
            <SwiperSlide key={index}>
              <div
                className={styles.card}
                onClick={() => {
                  scTrack(Event.Web3UserClick, {
                    page_name: Page.Home,
                    area: 'Banner',
                    button_name: 'MainBanner',
                    params: isMobile ? banner.appGoUrl : banner.webGoUrl,
                  });
                  if (isMobile) {
                    if (banner.appGoUrl) {
                      openLink(`${banner.appGoUrl}`);
                    }
                    return;
                  }
                  window.open(domainAbsolutePathReplace(banner.webGoUrl));
                }}
              >
                <img
                  className={styles.image}
                  alt="img"
                  src={replaceBybitToLocationHost(
                    isMobile ? banner.appPicUrl : banner.webPicUrl
                  )}
                />
                <div className={styles.area}>
                  <div className={styles.title}>{banner.title}</div>
                  <div className={styles.subTitle}>{banner.subtitle}</div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
